import { Outlet } from 'react-router-dom';
import { Header, MobileHeader } from '../Header';
import { BottomNav } from '../BottomNav';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      {/* Desktop header - hidden on mobile */}
      <Header />
      
      {/* Mobile header - hidden on desktop */}
      <MobileHeader />

      {/* Main content */}
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>

      {/* Bottom navigation - visible on mobile only */}
      <BottomNav />
    </div>
  );
}
